// paymentPolicy.ts
import { SelectOption } from "../../model/product.cart.model";

function pad4(n: number): string {
  return String(n).padStart(4, "0");
}

export function createPaymentDayOptions(maxDays: number): SelectOption[] {
  const safeMax =
    Number.isFinite(maxDays) && maxDays >= 0 ? Math.floor(maxDays) : 0;
  const options: SelectOption[] = [];

  for (let d = 0; d <= safeMax; d++) {
    const key = pad4(d);
    const value = d === 0 ? "À vista" : `${d} dia(s)`;
    options.push({ key, value });
  }
  return options;
}

/**
 * Regra de pagamento:
 * - maxPayCondDays vem do payCond específico do produto, senão do payCond do cliente, senão 0
 * - se max=0 => só "T" e prazo "0000"
 * - senão => "T" e "B", opções 0000..000N, e inicial para precificar é "0001"
 * - método é derivado do prazo: 0000 => T, >0000 => B
 * - "Ticket" força prazo = max, "Transfer" força prazo = 0000
 */
